import type { ContactRow } from './types';

/**
 * Block 12 «Контакты исполнителя» — defaults.
 *
 * **PR-H7 (ADR-0030 §8):** убрана строка «Название мебели» (`furniture-name`)
 * из default-списка. Aibek decision 2026-05-28: instance name не используется
 * на практике, дублирует contract-side responsibility, занимает UI место.
 * Default списка сейчас — 2 строки:
 *   - fio: Имя (исполнителя)
 *   - phone: Телефон (исполнителя)
 *
 * `FURNITURE_NAME_CONTACT_ID` export **сохранён** для legacy hydration filter
 * (HYDRATE reducer action отбрасывает row с этим id из старых drafts
 * с 3-contact array, см. `quoteReducer.ts`).
 *
 * **Auth auto-fill — deferred (BACKLOG B-119, not opened).** PRD говорит
 * «Подтягивается из профиля пользователя по умолчанию», но `useAuth` hook в
 * проекте сейчас отсутствует. Default value='' для всех полей; пользователь
 * заполняет вручную.
 */
export const DEFAULT_CONTACTS: ReadonlyArray<ContactRow> = [
  { id: 'fio', label: 'Имя', value: '' },
  { id: 'phone', label: 'Телефон', value: '' },
];

/**
 * **PR-H7 (ADR-0030):** ID legacy «Название мебели» строки. Хранится как
 * export-only constant для filter старых drafts при hydration —
 * `executorContacts.filter(r => r.id !== FURNITURE_NAME_CONTACT_ID)`.
 *
 * Сама строка больше НЕ в `DEFAULT_CONTACTS` (не создаётся для новых КП),
 * но старые IDB-записи с 3-contact array могут содержать её. Filter удаляет
 * row из `state.executorContacts` на read time (HYDRATE reducer action +
 * defensive PARTIAL_RESEED strip). IDB record при этом не переписывается
 * — следующий save проиcходит с обновлённым 2-row state.executorContacts,
 * а legacy row уже отсутствует. Эффективно — read filter cleanup происходит
 * естественно при следующем save flow.
 */
export const FURNITURE_NAME_CONTACT_ID = 'furniture-name';

/** Поле row, поддерживающее edit (Phase D4 reducer action CONTACT_UPDATE). */
export type ContactField = 'label' | 'value';
